<div class="wo-app-logout-container">
  <img [src]="'wo-common/assets/swc-logo_180x166.webp' | woFileHash" alt="ISS" class="wo-app-logout-logo"/>
  <div class="wo-app-logout-title wo-app-logout__title">
    {{ appName }}
  </div>
  <div class="wo-app-logout-field">
    <div class="wo-app-logout-msg">{{ 'iss-wo-common.auth.post-logout' | translate }}</div>
  </div>
  <div class="wo-app-logout-field">
    <button
      tuiButton appearance="outline"
      class="wo-app-logout__continue"
      (click)="login.emit()"
    >
      {{ 'iss-wo-common.auth.login-again' | translate  }}
    </button>
  </div>
</div>
